/* eslint-disable */


/**
 * Create styles for `<Selections />`
 * @param {Styles} styles The result of `createStyles`
 * @returns The `<Selections />` styles
 */
const selectionsStyles = ({ theme }) => ({
  addressListItem: {
    whiteSpace: `nowrap`,
  },
});

export default selectionsStyles;
